export default {
  send(message) {
    window.parent.postMessage(message, '*');
  }
}
